// 引入语言文件
import enLocale from '@user-center/locales/chinaKeys/en.json'
import jaJPLocale from '@user-center/locales/chinaKeys/ja_JP.json'
import viVNLocale from '@user-center/locales/chinaKeys/vi_VN.json'
import zhHansLocale from '@user-center/locales/chinaKeys/zh-Hans.json'
import zhHantLocale from '@user-center/locales/chinaKeys/zh-TW.json'

import zhHansEnKeyLocale from '@user-center/locales/enKeys/zh-CN.json'
import enEnKeyLocale from '@user-center/locales/enKeys/en.json'
import viVNEnKeyLocale from '@user-center/locales/enKeys/vi_VN.json'
import zhTwEnKeyLocale from '@user-center/locales/enKeys/zh-TW.json'
import jaJpEnKeyLocale from '@user-center/locales/enKeys/ja_JP.json'

import { zhTranFn } from '@user-center/utils/zh.ts'
import {get,merge,cloneDeep} from 'lodash-es'
import { createI18n } from 'vue-i18n'

const newHantJson: any = merge(cloneDeep(zhHansLocale), zhHantLocale)

// function tranStrToAllKeys(obj: any): void {
//   lodash.forEach(obj, function (value: any, key: any) {
//     if (lodash.isObject(value)) {
//       tranStrToAllKeys(value);
//     } else {
//       obj[key] = zhTranFn(obj[key], "t");
//     }
//   });
// }
// tranStrToAllKeys(newHantJson);

const messages = {
  'zh-CN':merge(zhHansLocale,zhHansEnKeyLocale),
  'zh-Hans':merge(zhHansLocale,zhHansEnKeyLocale),
  'zh-Hant': merge(newHantJson,zhTwEnKeyLocale),
  'zh-TW': merge(newHantJson,zhTwEnKeyLocale),
  'en': merge(enLocale,enEnKeyLocale),
  'ja_JP': merge(jaJPLocale,jaJpEnKeyLocale),
  'ja': merge(jaJPLocale,jaJpEnKeyLocale),
  'vi_VN': merge(viVNLocale,viVNEnKeyLocale),
  'vi': merge(viVNLocale,viVNEnKeyLocale),
}

const DEFAULT_LOCALE = 'zh-Hant'

function getBrowserStorage(): Storage | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }
  if (typeof localStorage !== 'undefined') {
    return localStorage
  }
  return null
}

function getStoredLocale(key: string): string | null {
  return getBrowserStorage()?.getItem(key) || null
}

function setStoredLocale(key: string, value: string): void {
  getBrowserStorage()?.setItem(key, value)
}

function resolveInitialLocale(): string {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE
  }

  const currentUserCenterLocale = getStoredLocale('current_user_center_locale')
  if (currentUserCenterLocale) {
    setStoredLocale('now-locale', currentUserCenterLocale)
    return currentUserCenterLocale
  }

  const currentLocale = getStoredLocale('now-locale')
  if (currentLocale) {
    return currentLocale
  }

  setStoredLocale('now-locale', DEFAULT_LOCALE)
  return DEFAULT_LOCALE
}

let nowLocale: any = resolveInitialLocale()
// 创建 i18n 实例
const i18n = createI18n({
  locale: nowLocale, // 设置默认语言
  fallbackLocale: DEFAULT_LOCALE, // 如果当前语言没有对应的翻译，则回退到默认语言
  messages, // 设置语言信息
})

export function $t(name: string, data?: any): string {
   
  const currentLocale: any = get(i18n,'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
  if(get(i18n,'global.t')){
    return i18n.global.t(name,data);
  }
  let setText: string
    = (messages[currentLocale] && get(messages[currentLocale], name))
    || name
  if (setText && data && Object.keys(data) && Object.keys(data).length > 0) {
    Object.keys(data).map((k) => {
      if (typeof data[k] != 'undefined') {
        setText = setText.replace(`{${k}}`, data[k])
      }
    })
  }
  return setText
}


export function isLongLocale(locale: string ): boolean {
  let LongLocaleMap={
    'en':true,
    'ja_JP':true,
    'ja':true,
    'vi_VN':true,
    'vi':true,
  }
  return !!LongLocaleMap[locale]
}

export function isChinaLocale(locale: string ): boolean {
  let chinaLocaleMap={
    'zh-CN':true,
    'zh-Hans':true,
    'zh-Hant':true,
    'zh-TW':true,
  }
  return !!chinaLocaleMap[locale]
}
export function isTwLocale(locale?: string ): boolean {
  let chinaLocaleMap={
 
    'zh-Hant':true,
    'zh-TW':true,
  }

  
  return !!chinaLocaleMap[locale || getCurrentLocale()]
}
export function getCurrentLocale(){
  return get(i18n,'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
}
export function getCurrentLocaleTransferCode(){
  let code=getCurrentLocale();
  const codeMap={
    vi_VN:"vi",
    ja_JP:"ja",
  }
  return codeMap[code]?codeMap[code]:code;
}
export function isToTransfer(locale?: string ): boolean {
  if(!locale){
    locale = get(i18n,'global.locale.value') || getStoredLocale('now-locale') || DEFAULT_LOCALE
  }
   
  return !isChinaLocale(locale)
}

export function toggleLocale(locale: string ): boolean {
  setStoredLocale('current_user_center_locale', locale)
  setStoredLocale('now-locale', locale)
  nowLocale = locale
  if (typeof window !== 'undefined') {
    window.location.reload();
  }
  return true
}


export function getLocaleText(locale?: string ): string {
  if(!locale){
    locale = getStoredLocale('now-locale') || DEFAULT_LOCALE
  }
  const texts = {
    'zh-Hans':$t('text.zhHans'),
    'zh-Hant':$t('text.zhHant'),
    'zh-TW': $t('text.zhHant'),
    'en': $t('text.en'),
    'ja_JP': $t('text.ja'),
    'ja': $t('text.ja'),
    'vi':  $t('text.vi'),
    'vi_VN':  $t('text.vi'),
  }
  const shotTexts = {
    'zh-Hans':'zh',
    'zh-Hant':'zh-tw',
    'zh-TW':'zh-tw',
    'en': 'en',
    'ja_JP':'ja',
    'ja': 'ja',
    'vi':  'vi',
    'vi_VN': 'vi',
  }
  return shotTexts[locale]||''
}


export default i18n
